import React from 'react';
import SEO from '../components/SEO';
import { FIRMA } from '../data/firma';
import styles from '../css/modules/ContentPage.module.css';

const FAQ_ITEMS = [
  { q: 'Co to jest integracja sensoryczna?', a: 'Integracja sensoryczna to proces, dzięki któremu mózg odbiera bodźce z ciała i otoczenia oraz właściwie na nie reaguje.' },
  { q: 'Skąd wiem, że moje dziecko ma problem z przetwarzaniem integracji sensorycznej?', a: 'Niepokoić mogą m.in.: trudności z koncentracją, nadwrażliwość na dźwięki lub niektóre ubrania, niezdarność ruchowa (potykanie się), unikanie huśtawek lub przeciwnie - poszukiwanie mocnych bodźców, niechęć do zabaw masami plastycznymi, problemy z jedzeniem.' },
  { q: 'Czy każde dziecko potrzebuje terapii integracji sensorycznej?', a: 'Nie. Terapia jest potrzebna wtedy, gdy trudności wpływają na codzienne funkcjonowanie dziecka.' },
  { q: 'Kiedy zgłosić się do specjalisty integracji sensorycznej?', a: 'Gdy zachowania dziecka utrudniają naukę, sen, relaks, zabawę, samoobsługę lub relacje z innymi.' },
  { q: 'Czy z problemów sensorycznych się wyrasta?', a: 'Częściowo tak - mózg dojrzewa i uczy się strategii radzenia sobie. Czasem jednak bez wsparcia trudności utrzymują się.' },
  { q: 'Jak wygląda terapia integracji sensorycznej?', a: 'To ustrukturyzowana zabawa w specjalnie wyposażonej sali (piłki, maty, huśtawki, hamaki itp.), która stanowi trening dla mózgu.' },
  { q: 'Ile trwa terapia SI?', a: 'To zależy od potrzeb - zwykle od kilku miesięcy do kilku lat, z zajęciami 1-2 razy w tygodniu. Zajęcia odbywają się w Olsztynie na ul. Partyzantów 31/5.' },
  { q: 'Ile trwają jedne zajęcia integracji sensorycznej?', a: 'Standardowo około 45 minut.' },
  { q: 'Czy mogę ćwiczyć z dzieckiem w domu?', a: 'Tak. Terapeuta przygotowuje dietę sensoryczną - zestaw codziennych zabaw i aktywności do realizacji w domu.' },
  { q: 'Czy integracja sensoryczna wpływa na naukę w szkole?', a: 'Tak - trudności SI mogą negatywnie wpływać na pisanie, czytanie, koncentrację i regulację emocji.' },
  { q: 'Czy problemy z SI oznaczają, że dziecko ma autyzm?', a: 'Nie. Trudności sensoryczne mogą występować samodzielnie lub współwystępować z innymi zaburzeniami. W sprawie diagnozy spektrum autyzmu warto zgłosić się do Poradni Psychologiczno-Pedagogicznej.' },
];

const FAQ_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQ_ITEMS.map((it) => ({
    '@type': 'Question',
    name: it.q,
    acceptedAnswer: { '@type': 'Answer', text: it.a },
  })),
};

export default function FAQ() {
  return (
    <div className={styles.page}>
      <SEO
        title="FAQ - Najczęściej zadawane pytania | Sensorini Olsztyn"
        description="Odpowiedzi na najczęstsze pytania o integrację sensoryczną (SI) w Olsztynie: kiedy zgłosić się do specjalisty, jak wygląda terapia, jak długo trwa i jak wspierać dziecko w domu."
        image="/image/faq.webp"
        pathname="/faq/"
        type="article"
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(FAQ_SCHEMA) }} />

      <header className={styles.hero}>
        <span className={`${styles.blob} ${styles.blobA}`} aria-hidden="true" />
        <span className={`${styles.blob} ${styles.blobB}`} aria-hidden="true" />
        <div className={styles.heroInner}>
          <span className={styles.eyebrow}>Integracja Sensoryczna • Olsztyn</span>
          <h1 className={styles.h1}>FAQ - Najczęściej zadawane pytania</h1>
          <p className={styles.lead}>
            Zebraliśmy odpowiedzi na najczęstsze pytania dotyczące integracji sensorycznej (SI) i terapii w Olsztynie.
          </p>
        </div>
      </header>

      <div className={styles.wrap}>
        <div className={styles.faqList}>
          {FAQ_ITEMS.map((item, idx) => (
            <details className={styles.faqItem} key={idx}>
              <summary className={styles.question}>
                <span className={styles.qIndex}>{idx + 1}.</span> {item.q}
              </summary>
              <div className={styles.answer}>
                <p>{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>

      <section className={styles.ctaBand}>
        <div className={styles.ctaInner}>
          <h2>Masz pytanie, którego tu nie ma?</h2>
          <p>Napisz lub zadzwoń - chętnie doradzę i umówimy diagnozę integracji sensorycznej w Olsztynie.</p>
          <div className={styles.ctaBtns}>
            <a href="/diagnoza-sensoryczna-olsztyn/" className={styles.btnPrimary} data-cta="booking" data-cta-location="final">Umów diagnozę</a>
            <a href={`tel:${FIRMA.telefonE164}`} className={styles.btnGhost}>Zadzwoń: {FIRMA.telefon}</a>
          </div>
        </div>
      </section>
    </div>
  );
}
